import React, { useEffect } from "react";
import styles from "./ModalShell.module.css";

export default function ModalShell({
    open,
    onClose,
    header,
    children,
    footer,
    size = "md",
    closeOnBackdrop = true,
    closeOnEsc = true,
    className,
}) {
    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => (document.body.style.overflow = prev);
    }, [open]);

    useEffect(() => {
        if (!open || !closeOnEsc) return;
        const onKey = (e) => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, closeOnEsc, onClose]);

    if (!open) return null;

    return (
        <div
            className={styles.backdrop}
            onMouseDown={(e) => {
                if (closeOnBackdrop && e.target === e.currentTarget) onClose?.();
            }}
        >
            <div
                className={`${styles.card} ${styles[size]} ${className || ""}`}
                role="dialog"
                aria-modal="true"
                tabIndex={-1}
            >
                {header}
                <div className={styles.body}>
                    {children}
                </div>
                {footer}
            </div>
        </div>
    );
}
